import get from 'lodash/get';
import { createSelector } from 'reselect';

export const getPagination = (state) => get(state, 'costCenters.list.pagination', {});
export const getFilters = (state) => get(state, 'costCenters.list.filters', {});

export const getCostCentersIds = (state) => get(state, 'costCenters.list.result.costCenters', []);
export const getCostCenters = (state) => get(state, 'costCenters.list.entities.costCenters', {});

export const getIsLoading = (state) => get(state, 'costCenters.list.isLoading', false);
export const getNeedFetch = (state) => get(state, 'costCenters.list.needFetch', false);

export const getIsFetching = (state) => get(state, 'costCenters.form.isFetching', false);
export const getIsFetchingConfig = (state) =>
  get(state, 'costCenters.form.isFetchingConfig', false);
export const getIsSaving = (state) => get(state, 'costCenters.form.isSaving', false);
export const getEditing = (state) => get(state, 'costCenters.form.editing', false);

export const getVisibleCostCenters = createSelector(
  [getCostCentersIds, getCostCenters],
  (ids, costCenters) => ids.map((id) => costCenters[id]).filter((costCenter) => !costCenter.deleted)
);



// WEBPACK FOOTER //
// src/modules/secured/modules/cost_centers/selectors/cost_centers_selectors.js